import React from "react";
import { useIntl } from "react-intl";
import { localeConfig } from "../../../config/localeDriven";
import { StyledContactlessBanner } from "./StyledContactlessBanner";

export interface LocaleSensitiveContactlessBannerProps {
  additionalMetrics?: { source?: string };
}

export function LocaleSensitiveContactlessBanner({
  additionalMetrics = {},
}: LocaleSensitiveContactlessBannerProps) {
  const { locale } = useIntl();
  const showBanner = localeConfig(
    locale,
    "localeRoutes.covid19.showContactlessTab"
  );
  if (!showBanner) {
    return null;
  }
  return <StyledContactlessBanner additionalMetrics={additionalMetrics} />;
}
